import { render, staticRenderFns } from "./NlpHeader.vue?vue&type=template&id=787e381a&scoped=true"
import script from "./NlpHeader.vue?vue&type=script&lang=js"
export * from "./NlpHeader.vue?vue&type=script&lang=js"
import style0 from "./NlpHeader.vue?vue&type=style&index=0&id=787e381a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787e381a",
  null
  
)

export default component.exports